// extracted by mini-css-extract-plugin
export var content = "_nv-1";
export var fullScreen = "_nv-0";